// Globals
const breakpointNav = 1200;

const mobNavToggles = document.querySelectorAll('#bamboo1, #bamboo2');

[].forEach.call(mobNavToggles, function(toggle){
  toggle.addEventListener('click', toggleNav);
});

function toggleNav() {
  const bamboo1 = document.getElementById('bamboo1');
  const bamboo2 = document.getElementById('bamboo2');
  const mobNav = document.querySelector('.mobile__nav');
  const mobNavBg = document.querySelector('.mob-nav-bg');

  // Toggle menu
  mobNav.classList.toggle('active');
  mobNavBg.classList.toggle('active');

  // Swap bamboo icons
  if (bamboo1.style.display === 'none') {
    bamboo1.style.display = 'block';
    bamboo2.style.display = 'none';
  } else {
    bamboo1.style.display = 'none';
    bamboo2.style.display = 'block';
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function pauseAllMedia() {
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

jQuery(document).ready(function($) {
    $('.subscription_group').first().remove();
});
